import ShimmerText from "./Text";

export default ShimmerText;
